import { TagButtonProps } from './types';
import { IconButton } from '../icon-button';
import { Button, Container } from './styles';

export const TagButton = ({
  title,
  onClick,
  isSelected,
  palette = 'black',
}: TagButtonProps) => {
  if (isSelected) {
    return (
      <Container>
        <p>{title}</p>
        <IconButton icon="cross" iconColor="black" onClick={onClick} />
      </Container>
    );
  }

  return (
    <Button disabled={!onClick} onClick={onClick} palette={palette}>
      <p>{title}</p>
    </Button>
  );
};
